import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ArrowLeft, Loader2, FileCheck, FileType, FileImage } from "lucide-react";

const TEST_STATUS_BADGE = {
  passed: "bg-emerald-500/10 text-emerald-600",
  failed: "bg-red-500/10 text-red-600",
};

const formatKey = (key) =>
  key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());

export const VerificationHeader = ({
  test,
  completedCount,
  downloadingPdf,
  onBack,
  onDownloadPdf,
  onCompleteTest
}) => {
  const tags = [];
  if (test.serial_number) tags.push({ label: "S/N", value: test.serial_number });
  if (test.power_supply) tags.push({ label: "Power", value: test.power_supply });
  for (const [key, val] of Object.entries(test.custom_values || {})) {
    if (!val && val !== 0) continue;
    tags.push({ label: formatKey(key), value: String(val) });
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-testid="verification-header">
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={onBack} data-testid="back-btn">
          <ArrowLeft className="w-5 h-5" />
        </Button>
        <div>
          <h2 className="text-xl font-bold tracking-tight">{test.product_name}</h2>
          <div className="flex flex-wrap gap-1 mt-0.5">
            {tags.map((tag, i) => (
              <span key={i} className="inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
                <span className="font-medium text-foreground">{tag.label}:</span>
                {tag.value}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        {test.status !== "in_progress" && (
          <>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onDownloadPdf(false)}
              disabled={downloadingPdf}
              data-testid="download-summary-btn"
              title="Summary Report (No Images)"
            >
              {downloadingPdf === 'summary' ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <FileType className="w-4 h-4 mr-2" />
              )}
              Summary
            </Button>
            <Button
              variant="outline"
              size="sm"
              onClick={() => onDownloadPdf(true)}
              disabled={downloadingPdf}
              data-testid="download-full-btn"
              title="Full Report (With Images)"
            >
              {downloadingPdf === 'full' ? (
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              ) : (
                <FileImage className="w-4 h-4 mr-2" />
              )}
              Full Report
            </Button>
          </>
        )}
        {test.status === "in_progress" && completedCount === test.total_steps && (
          <Button onClick={onCompleteTest} data-testid="complete-test-btn">
            <FileCheck className="w-4 h-4 mr-2" />
            Complete Test
          </Button>
        )}
        <Badge
          variant="outline"
          className={TEST_STATUS_BADGE[test.status] || "bg-amber-500/10 text-amber-600"}
        >
          {test.status.replace("_", " ")}
        </Badge>
      </div>
    </div>
  );
};
